export default "__VITE_ASSET__4wDE3aIK__"